import Trucks from "./Trucks";

export default Trucks;
